/*
Componente para mostrar mensagem de erros para o usuário
*/

import { useEffect } from 'react';
import './ErrorNotification.css';
import { RiErrorWarningFill } from "react-icons/ri";

export const ErrorNotification = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 10000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="toast-notification">
      <RiErrorWarningFill size={20} />
      <span>{message}</span>
    </div>
  );
};